import { defineStore } from 'pinia'

export const useGlobalModalsStore = defineStore('globalModals', {
  state: () => ({
    alertModalConfig: {
      isOpen: false,
      title: null,
      titleCloseButton: null,
      closeEvent: null,
      messages: null
    },
    confirmModalConfig: {
      isOpen: false,
      title: null,
      description: null,
      cancelEvent: null,
      successEvent: null,
      titleSuccessButton: null,
      titleCancelButton: null,
      iconName: null
    }
  }),
  actions: {
    openConfirmModal (
      title = null,
      description = null,
      successEvent = null,
      cancelEvent = null,
      titleSuccessButton = null,
      titleCancelButton = null,
      iconName = null
    ) {
      this.confirmModalConfig = {
        isOpen: true,
        title,
        description,
        cancelEvent,
        successEvent,
        titleSuccessButton,
        titleCancelButton,
        iconName
      }
    },
    openAlertModal (
      title = null,
      titleCloseButton = null,
      closeEvent = null,
      messages = null
    ) {
      this.alertModalConfig = {
        isOpen: true,
        title,
        titleCloseButton,
        closeEvent,
        messages
      }
    }
  }
})
